export default {
  LIST(state, data) {
    state.letters = data
  },
  ORG_DISTRIBUTED_QUOTE(state, data) {
    state.orgDistributedQuotes = data
  },
  GET(state, item) {
    state.letter = { ...item }
  },
  SET_QUOTE_DISTRIBUTION_ITEM(state, item) {
    state.quoteDistributionItem = { ...item }
  },
  SET_QUOTE_DISTRIBUTION_ITEM_DC_TYPES(state, data) {
    state.quoteDistributionItemDcTypes = JSON.stringify(data)
  },
  OTM_BALANCE(state, data) {
    state.balance = data
  },
  ADDITIONAL_QUOTE_LIST(state, data) {
    state.additionalQuotes = data
  },
  ASK_QUOTE_LIST(state, data) {
    state.askQuotes = data
  },
  ASK_QUOTE_GET(state, data) {
    state.askQuote = { ...data }
  },
  SET_QUOTE_DISTRIBUTION(state, data) {
    state.quoteDistribution = { ...data }
  },
  OTM_ADDITIONAL_BALANCE(state, data) {
    state.additionalBalance = { ...data }
  },
}
